<template>
  <generic-container
    :title="$t('prototype composer')"
    icon="cubes"
    :header_buttons="header_buttons"
    ref="container"
  >
    <div class="ui container">
      <div class="ui three item pointing menu">
        <a data-tab="general" class="item active">
          <i class="info icon"></i>
          {{ $t("general") }}
        </a>
        <a data-tab="pages" class="item">
          <i class="file alternate icon"></i>
          {{ $t("pages") }}
        </a>
        <a data-tab="components" class="item">
          <i class="cubes icon"></i>
          {{ $t("components") }}
        </a>
      </div>
      <div data-tab="general" class="ui bottom attached tab active">
        <general :setup="setup" />
      </div>
      <div data-tab="pages" class="ui bottom attached tab">
        <pages :setup="setup" ref="pages" />
      </div>
      <div data-tab="components" class="ui bottom attached tab">
        <components :setup="setup" ref="components" />
      </div>
    </div>
  </generic-container>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import General from "./General.vue";
import Pages from "./Pages.vue";
import Components from "./Components.vue";
import { local_api, error_toast, success_toast } from "@/utils";

export default {
  name: "PrototypeComposerIndex",
  components: { GenericContainer, General, Pages, Components },
  filters: filters,
  props: {
    templates: Array,
  },
  data() {
    return {
      setup: {
        name: "",
        description: "",
        access_route: "",
        pages: [],
        components: [],
      },
      uuid: null,
      header_buttons: [{ icon: "blue save", click: this.save }],
      loading: false,
    };
  },
  computed: {},
  methods: {
    save() {
      let vm = this;
      local_api(vm, "post", "/prototype/composer/do-save", {
        i: vm.uuid,
        s: vm.setup,
      })
        .then(() => {
          success_toast(vm.$t("prototype saved"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    load_prototype(mdle) {
      let vm = this;
      local_api(vm, "post", "/prototype/composer/do-get", {
        i: mdle.uuid,
      })
        .then((prototype) => {
          if (prototype) {
            vm.uuid = prototype.uuid;
            vm.setup.name = prototype.name;
            vm.setup.description = prototype.description;

            let setup = JSON.parse(prototype.setup);
            vm.setup.access_route = setup.access_route;
            vm.setup.pages = setup.pages;
            vm.setup.components = setup.components;

            setTimeout(() => {
              vm.$refs.pages.itemize();
              vm.$refs.components.itemize();
            }, 500);
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  created() {},
  mounted() {
    // let vm = this;
    window.jQuery(".ui.pointing.menu .item").tab();
    window.jQuery(".ui.tabular.menu .item").tab();
  },
  watch: {
    loading() {
      this.$refs.container.set_loading(this.loading);
    },
  },
};
</script>
